import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 90vw;
  max-width: ${({ theme }) => theme.siteWidth};
  margin: 20px auto;
  margin-top: 24px;
  backgorund-color: red;
  @media ${({ theme }) => theme.devices.mobileL} {
    margin: 0 auto;
    margin-top: 24px;
  }
`;

export const ContainerPop = styled.div`
  display: flex;
  max-width: 640px;
  height: auto;
  margin-top: -40px;
`;

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  max-width: ${({ theme }) => theme.siteWidth};
  overflow: hidden;
  justify-content: center;
  margin: 0 auto;
  width: 100%;

  @media ${({ theme }) => theme.devices.tablet} {
    padding: 0;
    overflow: hidden;
  }
`;

export const Banner = styled.div`
  width: 100%;
  height: 200px;
  margin-top: 64px;
  background-image: url("https://storage.googleapis.com/rurax/assets/banners/agros-stores.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 20% 35%;

  button {
    width: fit-content;
    height: fit-content;
    margin-bottom: 24px;
  }
`;

export const BannerBlur = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  background-color: rgba(0, 0, 0, 0.4);
`;

export const BannerText = styled.p`
  color: white;
  font-weight: 700;
  font-size: 1.5rem;
  text-align: center;
  padding: 0 12px;

  @media ${({ theme }) => theme.devices.tablet} {
    font-size: 1.2rem;
  }
`;

export const TopBanner = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  max-width: ${({ theme }) => theme.siteWidth};
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
`;

export const PersonalCard = styled.img`
  height: 40px;
  margin-right: 10px;
`;

export const TopBannerText = styled.p`
  color: ${({ theme }) => theme.colors.black.normal};
  font-size: ${({ theme }) => theme.fontSizePx.lg};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 400;
`;

export const MiddleBanner = styled.div`
  background-image: url("/Mocks/bannerMiddle1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.siteWidth};
  margin-top: 24px;
  width: 100%;
  height: 475px;
`;

export const CategoryMiddleBanner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background-color: ${({ theme }) => theme.colors.newGreen.green3};
  color: ${({ theme }) => theme.colors.white.normal};
  border-radius: 60px;
  font-size: 16px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.inter};
  height: 24px;
  min-width: 100px;
  margin-left: 20%;
  margin-bottom: 24px;
  padding: 4px 16px 4px 16px;
`;

export const TitleMiddleBanner = styled.p`
  color: ${({ theme }) => theme.colors.white.normal};
  font-size: 56px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  width: 35%;
  margin: 0;
  margin-left: 20%;
  line-height: 56px;
`;

export const SubTitleMiddleBanner = styled.p`
  color: ${({ theme }) => theme.colors.white.normal};
  font-size: 18px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 400;
  width: 35%;
  margin-left: 20%;
  line-height: 32px;
`;

export const BtnReadMoreMiddleBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5%;
  margin-left: 22.5%;
`;
